import { render, staticRenderFns } from "./Aggregated.vue?vue&type=template&id=78cd405b&"
import script from "./Aggregated.vue?vue&type=script&lang=js&"
export * from "./Aggregated.vue?vue&type=script&lang=js&"
import style0 from "./Aggregated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports